// Mattermost short names → emoji. Reactions are stored by short name (as imported from
// Mattermost); the picker offers the common ones and a search by name.
const TABLE: Record<string, string> = {
  '+1': '👍',
  '-1': '👎',
  white_check_mark: '✅',
  heart: '❤️',
  joy: '😂',
  smile: '😄',
  slightly_smiling_face: '🙂',
  wink: '😉',
  tada: '🎉',
  clap: '👏',
  pray: '🙏',
  ok_hand: '👌',
  eyes: '👀',
  fire: '🔥',
  rocket: '🚀',
  muscle: '💪',
  thinking_face: '🤔',
  raised_hands: '🙌',
  100: '💯',
  heart_eyes: '😍',
  sunglasses: '😎',
  sweat_smile: '😅',
  rofl: '🤣',
  cry: '😢',
  scream: '😱',
  confused: '😕',
  x: '❌',
  warning: '⚠️',
  coffee: '☕',
  wave: '👋',
  // Names that are only displayed (older reactions, synonyms).
  thumbsup: '👍',
  thumbsdown: '👎',
  heavy_check_mark: '✔️',
  grinning: '😀',
  laughing: '😆',
  sob: '😭',
  beers: '🍻',
  point_up: '☝️',
  disappointed: '😞',
  star: '⭐',
  bulb: '💡',
  memo: '📝',
  calendar: '📅',
  bug: '🐛',
  lock: '🔒',
  hourglass: '⌛',
  question: '❓',
  exclamation: '❗',
  sparkles: '✨',
  partying_face: '🥳',
  facepalm: '🤦',
  shrug: '🤷',
  see_no_evil: '🙈',
  smiley: '😃',
  innocent: '😇',
  relieved: '😌',
  sleeping: '😴',
  zap: '⚡',
  trophy: '🏆',
  gift: '🎁',
  bell: '🔔',
  link: '🔗',
  paperclip: '📎',
  phone: '📞',
  email: '📧',
  house: '🏠',
  car: '🚗',
  sunny: '☀️',
  umbrella: '☂️',
};

/** The thirty offered first in the picker, in this order. */
export const COMMON = Object.keys(TABLE).slice(0, 30);

export function emoji(name: string): string {
  return TABLE[name] ?? `:${name}:`;
}

export function searchEmoji(query: string): string[] {
  const q = query.trim().toLowerCase().replace(/^:|:$/g, '');
  if (!q) return COMMON;
  return Object.keys(TABLE).filter((name) => name.includes(q));
}
